const SnsTypeEnum = {
  Google: 1,
  Facebook: 2,
};

export default SnsTypeEnum;